import { ControlListProps, useTranslations } from "@harea/component";
import StatusSelect from "../../../components/StatusSelect";
import DepartmentSelect from "../../../components/DepartmentSelect";

export const useDayOffControlFilterForm = (isAbsence?: boolean): ControlListProps => {
    const [USERS, DATE_RANGE, STATUS, DEPARTMENT, DATE_BEGIN, HOUR_BEGIN, HOUR_END] = useTranslations(i18n);

    return {
        data: {
            forms: [
                {
                    type: "select",
                    name: "employee",
                    label: USERS,
                    valueObject: true,
                    valueProperty: "id",
                    multiple: true,
                    GQLProps: {
                        gql: `
                            query {
                                contracts (filter:{ sort: [{ sort: "ASC", value: "user.fullName" }] }) {
                                    data{
                                        user {
                                            id fullName 
                                            profilePicture { id }
                                        }
                                    }
                                }
                            }
                        `,
                        rootProp: "contracts.data",
                        labelProp: "user.fullName",
                        valueProp: "user.id",
                        userIdProp: "user.id",
                    },
                },
                {
                    type: "date-picker-range",
                    name: "dateRange",
                    label: DATE_RANGE,
                },
                !isAbsence ? {
                    type: "status-select",
                    label: STATUS,
                    name: "status",
                } : undefined,
                // {
                //     type: "select",
                //     name: "department",
                //     label: DEPARTMENT,
                //     valueObject: true,
                //     valueProperty: "id",
                //     GQLProps: {
                //         gql: `
                //             query {
                //                 departments (filter:{ sort: [{ sort: "ASC", value: "designation" }] }) {
                //                     data {
                //                         id
                //                         designation
                //                         color
                //                         departmentKey
                //                     }
                //                 }
                //             }
                //         `,
                //         rootProp: "departments.data",
                //         labelProp: "designation",
                //         valueProp: "id",
                //     },
                // },
                {
                    type: "hour",
                    name: "hourBegin_infOrEquals",
                    label: HOUR_BEGIN,
                },
                {
                    type: "hour",
                    name: "hourEnd",
                    label: HOUR_END,
                }
            ],
            hideFooter: true,
            fields: {
                "status-select": StatusSelect,
            },
        },
    };
};

const i18n = [
    "std_employees",
    "std_daterange",
    "std_status",
    "std_department",
    "BSMRH.Vacation.Calendar.Event.Create.Vacation.Form.Label.DateAppointmentBegin",
    "BSMRH.Vacation.Calendar.Event.Create.Vacation.Form.Label.HourAppointmentBegin",
    "BSMRH.Vacation.Calendar.Event.Create.Vacation.Form.Label.HourAppointmentEnd",
];
